export default __webpack_public_path__ + "static/media/clough_thumb500px.02add456.jpg";